import { http } from "@/core/api/";

const apiUrl = "api/childcountore";

export const validateCertificationExistence = async params =>
  await http.get(`${apiUrl}/validatecertificationexistence`, {
    params
  });

export const createOreCertification = async payload =>
  await http.post(`${apiUrl}/save`, payload);

export const searchOreCertifications = async params =>
  await http.get(`${apiUrl}/search`, { params });

export const uploadOreCertification = async payload =>
  await http.post(`${apiUrl}/upload`, payload, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });

export const validateIsCertificationApprovable = async childCountOreCertificationId =>
  await http.get(
    `${apiUrl}/validateisapprovable/${childCountOreCertificationId}`
  );

export const switchCertificationStatus = async payload =>
  await http.put(`${apiUrl}/switchstatus`, payload);

export const getCertificationStatusHistory = async params =>
  await http.get(`${apiUrl}/statushistory`, { params });

export const getCentersWithoutCertification = async academicYearId => {
  return await http.get(
    `${apiUrl}/centers-whitout-certification/${academicYearId}`
  );
};
